import { Input } from 'antd';
import React from 'react';

const InputComponent = (props) => {
  
  const handleChange = (e) => {
    if (typeof props.onChange === 'function') {
      props.onChange(e.target.value);
    }
  };

  return (
    <Input
      maxLength={1500}
      {...props}
      onChange={handleChange}
    />
  );
};

export default InputComponent;